import { useState } from 'react'
import { coursesAPI } from '../../services/api'
import type { CourseReportReason } from '../../types'
import { apiErrorMessage } from '../../utils/apiError'

const REASONS: [CourseReportReason, string][] = [
  ['spam', 'Spam'],
  ['abuse', 'Abuse'],
  ['misleading', 'Misleading'],
  ['other', 'Something else'],
]

/** "Report": pick a reason and it goes to FinCreator's admins, once. */
const ReportButton = ({ itemType, itemId }: { itemType: 'review' | 'discussion' | 'reply'; itemId: number }) => {
  const [open, setOpen] = useState(false)
  const [reason, setReason] = useState<CourseReportReason>('spam')
  const [state, setState] = useState<'idle' | 'sending' | 'sent'>('idle')
  const [error, setError] = useState<string | null>(null)

  if (state === 'sent') return <span className="text-xs text-gray-500">Reported</span>
  if (!open)
    return (
      <button type="button" onClick={() => setOpen(true)} className="text-xs text-gray-500 hover:underline">
        Report
      </button>
    )
  const send = async () => {
    setState('sending')
    setError(null)
    try {
      await coursesAPI.report(itemType, itemId, reason)
      setState('sent')
    } catch (e) {
      setError(apiErrorMessage(e, "Couldn't send the report."))
      setState('idle')
    }
  }
  return (
    <span className="inline-flex flex-wrap items-center gap-1 text-xs">
      <label className="sr-only" htmlFor={`report-${itemType}-${itemId}`}>
        Why
      </label>
      <select
        id={`report-${itemType}-${itemId}`}
        value={reason}
        onChange={(e) => setReason(e.target.value as CourseReportReason)}
        className="rounded border border-terminal-border bg-terminal-bg px-1 text-gray-200"
      >
        {REASONS.map(([value, label]) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
      <button type="button" onClick={send} disabled={state === 'sending'} className="text-sky-300 hover:underline">
        Send report
      </button>
      <button type="button" onClick={() => setOpen(false)} className="text-gray-500">
        Cancel
      </button>
      {error && <span className="text-amber-300">{error}</span>}
    </span>
  )
}

export default ReportButton
